import { SUPPORT_PHONE_E164 } from '@/lib/constants';
import { LOGGER_ACTIONS, logger } from '@/lib/logger';
import { cn } from '@/lib/utils';

interface ContactSupportLinkProps {
  className?: string;
}

export function ContactSupportLink({ className }: ContactSupportLinkProps) {
  return (
    <p className={cn('text-center text-sm text-charcoal-500', className)}>
      Need assistance?{' '}
      <a
        href={`tel:${SUPPORT_PHONE_E164}`}
        className="hover:text-hydrangea-700 font-medium text-hydrangea-500 underline underline-offset-auto transition-colors"
        onClick={() => logger.action(LOGGER_ACTIONS.ORDER_LOOKUP.CONTACT_SUPPORT_CLICKED)}
      >
        Contact Support
      </a>
    </p>
  );
}
